import {
  DisplayAmountMerchant,
  DisplayDateTimeMerchant,
  DisplayIdMerchant
} from "../../../../../../helpers/Display/DataDisplay";
import upperFirst from "mn-utils/upperFirst";
import React from "react";

export const columnsList = [
  {
    minWidth: 300,
    label: 'ID',
    dataKey: 'id',
    dataHandler: ({id}) => (
      <DisplayIdMerchant>
        {id}
      </DisplayIdMerchant>
    )
  },
  {
    minWidth: 250,
    label: 'Amount',
    dataKey: 'amount',
    dataHandler: ({total_amount, sc_code, fiat_code}) => (
      <DisplayAmountMerchant
        amount={total_amount}
        symbol={sc_code || fiat_code}
        type="fiat"
      />
    )
  },
  {
    minWidth: 250,
    label: 'Fee',
    dataKey: 'fee',
    dataHandler: ({invoice_amount, sc_code, fiat_code}) => (
      <DisplayAmountMerchant
        amount={invoice_amount}
        symbol={sc_code || fiat_code}
        type="fiat"
      />
    )
  },
  {
    minWidth: 150,
    label: 'Trx Count',
    dataKey: 'total_entries',
  },
  {
    minWidth: 150,
    label: 'Date',
    dataKey: 'created_at',
    dataHandler: ({created_at}) => (
      <DisplayDateTimeMerchant
        date={created_at}
      />
    )
  },
  {
    minWidth: 175,
    label: 'Status',
    dataKey: 'tx_status',
    dataHandler: ({lifeflow = ''}) => {
      return (
        <div
          className={
            `lh lts0em c0 cFFBF43.pending c2CE889.paid
              c8.canceled cEE4F4F.failed c5B47FF.initiated ` + lifeflow
          }
        >
          {upperFirst(lifeflow)}
        </div>
      )
    }
  },
];
